import { DayOfWeek } from '@askporter/client-grieg-lyric';

export const filterNoServiceTimeDays = <T>(dayTimes: Record<DayOfWeek, T>): Record<DayOfWeek, T> => {
  const newDayTimes = { ...dayTimes };
  Object.keys(dayTimes).forEach((day) => {
    if (dayTimes[day as DayOfWeek] === null) {
      delete newDayTimes[day as DayOfWeek];
    }
  });
  return newDayTimes;
};
